<template>
  <div class="ReportStatus">
    <div
      v-if="status === 'DRAFT'"
      class="report-status draft">
      <Icon name="error" />Waiting for submittal
    </div>
    <div
      v-if="status === 'SUBMITTED'"
      class="report-status submitted">
      <Icon name="success" />
      Submitted
    </div>
  </div>
</template>

<script>
export default {
  data: function () {
    return {};
  },

  props: {
    status: {
      type: String,
      default: "DRAFT",
    },
  },

  mounted() {},

  methods: {},

  computed: {},

  filters: {},
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/responsive";
.ReportStatus {
  .report-status {
    opacity: 0.54;
    flex: 1;
    padding-left: 1em;

    @include phone {
      padding-left: inherit;
    }

    &.submitted {
      color: var(--dark-seafoam);
      opacity: 1;
      font-weight: bold;
    }
  }
}
</style>
